import React from "react";
import cx from "classnames";
import ReactSlider from "react-slick";
import { graphql, useStaticQuery } from "gatsby";

import { latestUpdatesPrepareData } from "utils/latestUpdatesPrepareData";
import { Heading } from "components/ui/Heading";
import { Button } from "components/ui/Button";
import { Section } from "components/common/Section";
import { Container } from "components/common/Container";

import { UpdateCard } from "./UpdateCard";
import { SubscriptionForm } from "./SubscriptionForm";
import * as s from "./LatestUpdates.module.sass";

const sliderSettings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: false,
  infinite: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        arrows: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        arrows: false,
      },
    },
  ],
};

export const LatestUpdates: FC = ({ className }) => {
  const data = useStaticQuery(graphql`
    query LatestUpdates {
      allWpPost(sort: { date: DESC }, limit: 3) {
        edges {
          node {
            title
            uri
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 800
                      placeholder: BLURRED
                      outputPixelDensities: 1.5
                      quality: 90
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const posts = latestUpdatesPrepareData(data);

  return (
    <Section className={cx(s.root, className)}>
      <Container className={s.container}>
        <Heading className={s.heading}>Our latest updates</Heading>
        <ReactSlider {...sliderSettings} className={s.slider}>
          {posts.map((update: any) => (
            <div key={update.uri}>
              <UpdateCard update={update} />
            </div>
          ))}
        </ReactSlider>
        <Button className={s.button} href={process.env.GATSBY_BLOG_LINK}>
          Visit our blog
        </Button>
      </Container>
      <SubscriptionForm />
    </Section>
  );
};
